// 首先导入polyfill以确保浏览器兼容性
import './polyfills'

// IE11专用：阻止控制台错误显示
// 有些第三方库可能使用console.* API而IE11不支持这些API时会显示错误
;(function () {
  if (typeof window === 'undefined') return
  // 确保IE下console对象存在且其方法存在
  if (!window.console) (window as any).console = {}
  const methods = [
    'log',
    'info',
    'warn',
    'error',
    'debug',
    'trace',
    'dir',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeEnd',
  ]
  for (const method of methods) {
    if (!(method in window.console)) {
      ;(window.console as any)[method] = function () {}
    }
  }
})()

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import './i18n' // 导入i18n配置

// 尝试创建root元素
let root
try {
  // 使用新的React 18 API
  root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
} catch (error) {
  console.error('React DOM render error:', error)
  // 对于可能不支持createRoot API的浏览器(如果降级到React 17/16)，这可以作为备选方案
  // 但需要确保你的项目支持这个降级处理
  const rootElement = document.getElementById('root')
  if (rootElement && (ReactDOM as any).render) {
    try {
      ;(ReactDOM as any).render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
        rootElement
      )
    } catch (fallbackError) {
      console.error('Fallback render also failed:', fallbackError)
    }
  }
}

// 简化版本，用于消除导入错误
const reportWebVitals = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Web Vitals reporting would be initialized here')
  }
}

reportWebVitals()
